import { Table, TableBody, TableCell, TableRow } from '@material-ui/core';

export function createData(regex: string, description: string) {
  return { regex, description };
}

const rows = [
  createData('[xyz]', 'Matches any one of the enclosed characters'),
  createData(
    '[^xyz]',
    'Matches anything that is not enclosed in the square brackets',
  ),
  createData('.', 'Matches any single character except line terminators.'),
  createData('\\d', 'Matches any digit-[0-9]'),
  createData('\\w', 'Matches any alphanumeric character-[A-Za-z0-9_]'),
  createData('\\s', 'Matches a single white space character'),
  createData('\\t', 'Matches a horizontal tab'),
  createData('\\r', 'Matches a carriage return'),
  createData('\\n', 'Matches a linefeed'),
  createData('\\v', 'Matches a vertical tab'),
  createData('\\f', 'Matches a form-feed'),
  createData('[\\b]', 'Matches a backspace'),
  createData('\\0', 'Matches a NUL character'),
  createData('x|y', 'Matches either "x" or "y"'),
];

export function CharacterClasses() {
  return (
    <>
      <h3>Character Classes</h3>
      <Table size="small">
        <TableBody>
          {rows.map(row => (
            <TableRow>
              <TableCell>{row.regex}</TableCell>
              <TableCell align="right">{row.description}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </>
  );
}
